export default "__VITE_ASSET__cb40bd6f__"